import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IffhsService } from 'src/app/data-services/iffhs.service';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { UserService } from 'src/app/data-services/user.service';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
declare var $: any;

@Component({
  selector: 'app-dashboard-add-club',
  templateUrl: './dashboard-add-club.component.html',
  styleUrls: ['./dashboard-add-club.component.css']
})
export class DashboardAddClubComponent implements OnInit {

  sidebar: any;
  clubForm: FormGroup;
  id: number;
  countryData: any = {};
  searchText: any;
  currentUser: any;
  isLoaderVisible = false;
  submitted = false;
  countryId: number;
  countryName: string;
  fileName: string;
  onChangeValue = '';
  leagues = [];

  constructor(
    private route: ActivatedRoute,
    private iffhsService: IffhsService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastrService: ToastrService,
  ) { }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.route.queryParams.subscribe(params => this.id = params.id);
    this.countryDetails();
    this.getLeaguesByCountry();
    this.clubForm = this.formBuilder.group({
      countryId: [this.id],
      leagueId: ['', Validators.required],
      clubName: ['', Validators.required],
      countryName: [this.countryName],
      clubAvatar: ['', Validators.required],
      createdBy: [this.currentUser.success.user.id],
    });
  }
  toggleSideBar(event) {
    $(".profile-settings-open").on('click', function () {
      $('.profile-settings-responsive').toggleClass('open');
      return false;
    });
  }
  ngAfterViewInit(): void {
    this.sidebar = $('.js-profile-settings-open');
  }
  countryDetails() {
    this.isLoaderVisible = true;
    const data = {
      countryId: this.id,
    };
    this.iffhsService.getCountryDetails(data).pipe(first<any>())
      .subscribe(countryData => this.countryData = countryData[0]);
    this.countryId = this.countryData.id;
    this.countryName = this.countryData.name;
    this.isLoaderVisible = false;
  }
  onFileSelect(event) {
    const clubAvatar = event.target.files[0];
    const type = event.target.files[0].type;
    if (type.match(/image\/*/) === null) {
      this.toastrService.error('Only images are supported', 'Message!');
      return;
    }
    this.fileName = event.target.files[0].name;
    this.clubForm.get('clubAvatar').setValue(clubAvatar);

  }

  onChange(e) {
    this.onChangeValue = e.target.value || 0;
  }
  getLeaguesByCountry() {
    this.isLoaderVisible = true;
    const data = {
      countryId: this.id,
    };
    this.iffhsService.getLeaguesByCountry(data).subscribe((res: any) => {
      this.leagues = res.leagues;
      this.isLoaderVisible = false;
    });
  }

  get f() { return this.clubForm.controls; }
  onSubmitClub() {
    this.submitted = true;
    if (this.clubForm.invalid) {
      return;
    }
    this.isLoaderVisible = true;
    const fd = new FormData();
    fd.append('countryId', this.clubForm.get('countryId').value);
    fd.append('leagueId', this.clubForm.get('leagueId').value);
    fd.append('clubName', this.clubForm.get('clubName').value);
    fd.append('countryName', this.countryName);
    fd.append('clubAvatar', this.clubForm.get('clubAvatar').value, 'avatar.png');
    fd.append('createdBy', this.clubForm.get('createdBy').value);
    this.iffhsService.addClub(fd).pipe(first()).subscribe(
      data => {
        this.toastrService.success('Club has been Added!', 'Message!');
        this.isLoaderVisible = false;
      },
      error => {
        console.log(error);
        this.toastrService.error('Something went wrong please Try Later!', 'Message!');
        this.isLoaderVisible = false;
      }
    );

    this.clubForm = this.formBuilder.group({
      countryId: [this.id],
      leagueId: [''],
      clubName: [''],
      countryName: [this.countryName],
      clubAvatar: [''],
      createdBy: [this.currentUser.success.user.id],
    });
  }
}
